import React, { useState } from 'react';
import { useMutation } from 'hooks/apollo';
import { gql } from '@apollo/client';

import { FormattedMessage } from 'react-intl';
import { Button, Form, Checkbox } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import InfoToolip from 'components/InputInfoCircle';
import Modal from 'components/Modal';
import RichTextInput from 'components/RichTextInput';

import useGlobalContext from 'hooks/useGlobalContext';
import useFormatMessage from 'hooks/useFormatMessage';

import messages from './messages';
import './intro-closing.less';

const EDIT_INTRO = gql`
  mutation($settingsId: ID!, $content: String, $showOnSeparatePage: Boolean) {
    updateWelcomeContent(settingsId: $settingsId, content: $content, showOnSeparatePage: $showOnSeparatePage) {
      id
    }
  }
`;

const EDIT_CLOSING = gql`
  mutation($settingsId: ID!, $content: String) {
    updateClosingContent(settingsId: $settingsId, content: $content) {
      id
    }
  }
`;

export const EditIntro = ({
  settingsId, content, showOnSeparatePage,
}) => {
  const [form] = Form.useForm();
  const { message } = useGlobalContext();
  const $t = useFormatMessage();
  const [isOpen, setOpen] = useState(false);
  const [edit, { loading: saving }] = useMutation(EDIT_INTRO);
  const onCancel = () => setOpen(false);
  const onOk = async () => {
    try {
      await form.validateFields();
      form.submit();
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const save = async (values) => {
    try {
      const variables = {
        settingsId,
        showOnSeparatePage: values.showOnSeparatePage,
        content: values.content,
      };
      await edit({ variables });
      message.success($t(messages.introSaveSuccess));
    } catch (error) {
      message.error($t(messages.introSaveFail));
    }
  };

  const initalValues = { content, showOnSeparatePage };
  return (
    <>
      <Modal
        title={<FormattedMessage {...messages.editIntro} />}
        open={isOpen}
        maskClosable={false}
        okText={<FormattedMessage {...messages.save} />}
        onOk={onOk}
        onCancel={onCancel}
        confirmLoading={saving}
        fullWidth
        destroyOnClose
      >
        <Form layout="vertical" form={form} onFinish={save} initialValues={initalValues}>
          <Form.Item name="content">
            <RichTextInput />
          </Form.Item>
          <Form.Item name="showOnSeparatePage" valuePropName="checked" style={{ marginBottom: 0 }}>
            <Checkbox>
              <FormattedMessage {...messages.showOnSeparatePage} />
              <span style={{ marginLeft: 8 }}>
                <InfoToolip placement="right" title={<FormattedMessage {...messages.separatePageTooltip} />} />
              </span>
            </Checkbox>
          </Form.Item>
        </Form>
      </Modal>
      <div className="survey-intro">
        <LockOutlined className="survey-intro__icon" />
        <div className="survey-intro__button">
          <Button type="link" block onClick={() => setOpen(true)}>
            <FormattedMessage {...messages.introTitle} />
          </Button>
        </div>
      </div>
    </>
  );
};

export const EditClosing = ({
  settingsId, content,
}) => {
  const [form] = Form.useForm();
  const [isOpen, setOpen] = useState(false);
  const [edit, { loading: saving }] = useMutation(EDIT_CLOSING);
  const { message } = useGlobalContext();
  const $t = useFormatMessage();

  const onCancel = () => setOpen(false);
  const onOk = async () => {
    try {
      await form.validateFields();
      form.submit();
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const save = async (values) => {
    try {
      const variables = {
        settingsId,
        content: values.content,
      };
      await edit({ variables });
      message.success($t(messages.closingSaveSuccess));
    } catch (error) {
      message.error($t(messages.closingSaveFail));
    }
  };

  const initalValues = { content };

  return (
    <>
      <Modal
        title={<FormattedMessage {...messages.editClosing} />}
        open={isOpen}
        maskClosable={false}
        okText={<FormattedMessage {...messages.save} />}
        onOk={onOk}
        onCancel={onCancel}
        confirmLoading={saving}
        fullWidth
        destroyOnClose
      >
        <Form layout="vertical" form={form} onFinish={save} initialValues={initalValues}>
          <Form.Item name="content" style={{ marginBottom: 0 }}>
            <RichTextInput />
          </Form.Item>
        </Form>
      </Modal>
      <div className="survey-closing">
        <LockOutlined className="survey-closing__icon" />
        <div className="survey-closing__button">
          <Button type="link" block onClick={() => setOpen(true)}>
            <FormattedMessage {...messages.closingTitle} />
          </Button>
        </div>
      </div>
    </>
  );
};
